
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/group",
      function () {
        return require("private-next-pages/special-offers/group.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-offers/group"])
      });
    }
  